module.exports = __webpack_public_path__ + "media/images/banks/cimb-ff2cac615de902c0c882362c56a94387.png";